import React from "react";

import './Footer.css'
// import Wave from "../../img/wave.png";

const Footer =()=>{
  
    return(
        
        <div className="footer">
            {/* <img src={Wave} alt=""style={{width:'100%',height:'20%'}}/> */}
            <div className="f-content">
                <span style={{color:'purple'}}> missbinarybeauty456@gmail.com</span>
               
            </div>
        </div>
    )
}
export default Footer;